export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export interface Category {
  id: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  { id: "shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", icon: "ri-footprint-line" },
  { id: "hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", icon: "ri-shirt-line" },
  { id: "tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", icon: "ri-t-shirt-line" },
  { id: "jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", icon: "ri-haze-line" },
  { id: "pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", icon: "ri-more-line" },
  { id: "headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", icon: "ri-user-5-line" },
  { id: "sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", icon: "ri-stack-line" },
  { id: "underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", icon: "ri-box-3-line" },
  { id: "jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", icon: "ri-t-shirt-line" },
  { id: "accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", icon: "ri-vip-diamond-line" },
  { id: "bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", icon: "ri-briefcase-4-line" },
  { id: "belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", icon: "ri-menu-2-line" },
  { id: "perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", icon: "ri-drop-line" },
  { id: "other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", icon: "ri-more-2-line" },
];